import React, { useState } from 'react';
import { FiSearch, FiAlertCircle } from 'react-icons/fi';
import Input from '../../Common/Input';
import Button from '../../Common/Button';
import styles from './PNRForm.module.css';

interface PNRFormProps {
  onSubmit: (pnr: string) => void;
  isLoading: boolean;
}

const PNRForm: React.FC<PNRFormProps> = ({ onSubmit, isLoading }) => {
  const [pnr, setPnr] = useState('');
  const [error, setError] = useState('');

  const validatePNR = (value: string): boolean => {
    const pnrRegex = /^\d{10}$/;
    return pnrRegex.test(value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!pnr.trim()) {
      setError('Please enter a PNR number');
      return;
    }

    if (!validatePNR(pnr)) {
      setError('PNR number must be exactly 10 digits');
      return;
    }

    onSubmit(pnr);
  };

  const handlePNRChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPnr(value);
    if (error) setError('');
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.inputWrapper}>
        <Input
          type="text"
          value={pnr}
          onChange={handlePNRChange}
          placeholder="Enter 10-digit PNR number"
          label="PNR Number"
          error={error}
          icon={<FiSearch />}
          fullWidth
          maxLength={10}
          autoFocus
        />
        {error && (
          <div className={styles.errorMessage}>
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}
      </div>

      <Button
        type="submit"
        variant="primary"
        size="lg"
        fullWidth
        isLoading={isLoading}
      >
        {isLoading ? 'Checking Status...' : 'Check PNR Status'}
      </Button>

      <div className={styles.hint}>
        <p>💡 Enter your 10-digit PNR number to get real-time status updates</p>
      </div>
    </form>
  );
};

export default PNRForm;